import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { threadList, signUp } from '@/api/mg';
// const threadListParams = { page: 1, perPage: 20 }
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 1,
  sequence: 0,
  'filter[categoryids][0]': 2
};
export default {
  data: function data() {
    return {
      totalPage: 0,
      loading: false,
      finished: false,
      isLoading: false,
      activityData: [],
      itemArr: [{
        isJoin: true
      }, {
        isJoin: false
      }, {
        isJoin: true
      }, {
        isJoin: true
      }, {
        isJoin: false
      }, {
        isJoin: true
      }, {
        isJoin: true
      }]
    };
  },
  created: function created() {
    threadListParams.page = 1;
    this.getThreadList(threadListParams);
  },
  methods: {
    toSign: function toSign(type, threadId, item) {
      var _this = this;
      signUp({
        threadId: threadId,
        type: type,
        token: JSON.parse(localStorage.getItem('appParams')).token
      }).then(function (res) {
        if (res.Code === 0) {
          _this.$toast(res.Message);
          if (item.activity_registration) {
            item.activity_registration = 0;
          } else {
            item.activity_registration = 1;
          }
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    onLoad: function onLoad() {
      threadListParams.page++;
      if (threadListParams.page <= this.totalPage) {
        this.getThreadList(threadListParams);
      } else {
        this.finished = true;
      }
    },
    getThreadList: function getThreadList(params) {
      var _this2 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.pageData.length === 0) {
            _this2.$toast('No Data');
          }
          _this2.totalPage = res.Data.totalPage;
          _this2.activityData = [].concat(_toConsumableArray(_this2.activityData), _toConsumableArray(res.Data.pageData));
          _this2.loading = false;
          _this2.isLoading = false;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    onRefresh: function onRefresh() {
      this.finished = false;
      this.activityData = [];
      threadListParams.page = 1;
      this.getThreadList(threadListParams);
    },
    toDetail: function toDetail(val, threadId) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: val,
          threadId: threadId
        }
      });
    }
  }
};